"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreHeldBackAmountType = exports.CORE_DISPUTE_NO_SPECIFIC_MILESTONE = exports.CoreDisputeIssueType = exports.CoreClientReleaseReason = exports.CoreDesiredOutcome = void 0;
var CoreDesiredOutcome;
(function (CoreDesiredOutcome) {
    CoreDesiredOutcome["CLIENT_RELEASE_FUNDS"] = "CLIENT_RELEASE_FUNDS";
    CoreDesiredOutcome["REVISION_REWORK"] = "REVISION_REWORK";
    CoreDesiredOutcome["PARTIAL_REFUND"] = "PARTIAL_REFUND";
    CoreDesiredOutcome["FULL_REFUND"] = "FULL_REFUND";
    CoreDesiredOutcome["OTHER"] = "OTHER";
})(CoreDesiredOutcome || (exports.CoreDesiredOutcome = CoreDesiredOutcome = {}));
/** Reason the client gives for holding back funds. Asked of Interior Design (ID) businesses when the desired outcome is CLIENT_RELEASE_FUNDS. */
var CoreClientReleaseReason;
(function (CoreClientReleaseReason) {
    CoreClientReleaseReason["DEFECTS_WORKMANSHIP"] = "DEFECTS_WORKMANSHIP";
    CoreClientReleaseReason["OTHER"] = "OTHER";
})(CoreClientReleaseReason || (exports.CoreClientReleaseReason = CoreClientReleaseReason = {}));
/** Type of issue a client of an Interior Design (ID) company picks when raising a dispute (HAN-638). Not asked of anyone else. */
var CoreDisputeIssueType;
(function (CoreDisputeIssueType) {
    CoreDisputeIssueType["DEFECTS_WORKMANSHIP"] = "DEFECTS_WORKMANSHIP";
    CoreDisputeIssueType["PAYMENT_VARIATION"] = "PAYMENT_VARIATION";
    CoreDisputeIssueType["SCOPE_DELAY"] = "SCOPE_DELAY";
    CoreDisputeIssueType["OTHER"] = "OTHER";
})(CoreDisputeIssueType || (exports.CoreDisputeIssueType = CoreDisputeIssueType = {}));
/**
 * Value of "Which milestone is this about?" on the raise-dispute form when the dispute is not about one
 * specific milestone, including one that covers more than one (HAN-637). Any other value is a milestone id.
 */
exports.CORE_DISPUTE_NO_SPECIFIC_MILESTONE = 'NO_SPECIFIC_MILESTONE';
/**
 * Business "Client to release funds" disputes: how much the client is holding back (HAN-692).
 * FULL_BALANCE = the picked milestone's whole balance in escrow (worked out by the server); OTHER = an amount the business enters.
 */
var CoreHeldBackAmountType;
(function (CoreHeldBackAmountType) {
    CoreHeldBackAmountType["FULL_BALANCE"] = "FULL_BALANCE";
    CoreHeldBackAmountType["OTHER"] = "OTHER";
})(CoreHeldBackAmountType || (exports.CoreHeldBackAmountType = CoreHeldBackAmountType = {}));
